import { apiFetch } from "../api.js";
import type {
  CreateHousingExpenseInput,
  HousingExpense,
  HousingExpensesListResponse,
  UpdateHousingExpenseInput,
} from "./types.js";

export function listHousingExpenses(
  unitId: string,
  range?: { from: string; to: string },
): Promise<HousingExpensesListResponse> {
  const qs = range ? `?from=${range.from}&to=${range.to}` : "";
  return apiFetch<HousingExpensesListResponse>(
    `/v1/housing-units/${unitId}/expenses${qs}`,
  );
}

export function getHousingExpense(
  unitId: string,
  date: string,
  expenseId: string,
): Promise<HousingExpense> {
  return apiFetch<HousingExpense>(
    `/v1/housing-units/${unitId}/expenses/${date}/${expenseId}`,
  );
}

export function createHousingExpense(
  unitId: string,
  input: CreateHousingExpenseInput,
): Promise<HousingExpense> {
  return apiFetch<HousingExpense>(`/v1/housing-units/${unitId}/expenses`, {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function updateHousingExpense(
  unitId: string,
  date: string,
  expenseId: string,
  input: UpdateHousingExpenseInput,
): Promise<HousingExpense> {
  return apiFetch<HousingExpense>(
    `/v1/housing-units/${unitId}/expenses/${date}/${expenseId}`,
    {
      method: "PATCH",
      body: JSON.stringify(input),
    },
  );
}

export function deleteHousingExpense(
  unitId: string,
  date: string,
  expenseId: string,
): Promise<void> {
  return apiFetch<void>(
    `/v1/housing-units/${unitId}/expenses/${date}/${expenseId}`,
    { method: "DELETE" },
  );
}
